// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__k0Kgl","title":"HomePage_title__AUaMx"};